export class Header {
    static root;
    static inside;
    static container;
    static wrapper = null;
    static clone = null;

    // Gets called once when the class is first used.
    static {
        const root = document.getElementById('header');
        const inside = root.querySelector('.inside');
        const container = document.getElementById('container');

        if (!root || !inside || !container) {
            throw new Error('Could not find header elements.');
        }

        this.root = root;
        this.inside = inside;
        this.container = container;
    }

    // Get the current height of the header (including contact bar).
    static getHeight = () => this.container.offsetTop.toFixed(0);

    // Get the current height of the header (without contact bar).
    static getInnerHeight = () => this.root.getBoundingClientRect().height.toFixed(0);

    // Get the position from which the header should be fixed.
    static getFixedPosition = () => window.innerHeight / 2 + 300;

    /**
     * Calculate the regular height and sticky height of the header.
     * We need to know these values for CSS top offsets.
     */
    static calculateHeights = () => {
        this.wrapper ??= document.getElementById('wrapper');
        this.clone ??= Header.root.cloneNode(true);

        if (!this.wrapper || !(this.clone instanceof HTMLElement)) {
            console.error('Could not calculate header heights. Missing wrapper or clone element.');

            return;
        }

        // We clone the #header and append it off screen to the #wrapper. This way
        // we can calculate the height of the header (in sticky mode and regular mode)
        // without affecting the layout.

        this.clone.classList.remove('show', 'sticky');
        this.clone.removeAttribute('style');
        this.clone.style.position = 'absolute';
        this.clone.style.left = '-9999px';

        this.wrapper.appendChild(this.clone);

        // Regular Mode
        let height = this.clone.getBoundingClientRect().height.toFixed(0);
        Header.root.style.setProperty('--regular-height', `${height}px`);

        // Sticky Mode
        this.clone.classList.add('show', 'sticky');
        height = this.clone.querySelector('.inside').getBoundingClientRect().height.toFixed(0);
        Header.root.style.setProperty('--sticky-height', `${height}px`);

        this.wrapper.removeChild(this.clone);
    };
}

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const headerHeight = parseInt(Header.getHeight()) + 200;

    if (scrolledTop > headerHeight) {
        Header.root.classList.add('sticky');
    } else {
        Header.root.classList.remove('sticky');
    }

    if (scrolledTop > Header.getFixedPosition()) {
        Header.root.classList.add('show');
    } else {
        Header.root.classList.remove('show');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    Header.calculateHeights();
    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    Header.calculateHeights();
    showFixedHeader();
});
